module.exports = __webpack_public_path__ + "img/switch-block-icon.2ecb490b.svg";